import { Component, OnInit, Input, OnChanges, ViewChild } from '@angular/core';
import { SessionStorageService } from "ngx-webstorage";
import { ClienteLogin, ClienteXCiudad, Cliente, ClienteVAM, UsuarioVamTit, ClienteResumen, CiudadClienteNombre } from '../login/cliente_login';
import { UtilService } from '../../components/common/utils/util.service';
import { CitasAsesorVirtualService } from './citas-asesor-virtual.service';
import { CitasPendientes, AsesoriaVirtual, ComboSelect } from './citas-asesosr-virtual.entity';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { ConsultarUsuarioVAM } from '../../components/common/utils/consultarUsuarioVAM';
import { ConsultarUsuarioMasivos } from '../../components/common/utils/consultarUsuarioMasivos';
import { CIUDADES } from '../../components/common/cabecera/entity/ciudades';
import { ClienteIndividualEntity } from '../masivos/datosGenerales/entities/datos_generales_individual_entity';


const swal = require("sweetalert2");
declare var jQuery: any;

@Component({
  selector: 'citasAsesorVirtual',
  templateUrl: 'citas-asesor-virtual.template.html'
})
export class CitasAsesorVirtualComponent implements OnInit {
  usuario: ClienteLogin;
  showLoader: string;
  citas: CitasPendientes[] = new Array<CitasPendientes>();
  cancelarCitaEntity: AsesoriaVirtual = new AsesoriaVirtual();
  @ViewChild('cancelarCita')
  modalPass: ModalComponent;
  clienteVam: ClienteVAM;
  usuarioresumen: ClienteResumen;
  tipoSeguro: number = 0;
  tipoPoliza: number;
  tipoEmpresa: number;
  dataTipoSeguro: ComboSelect[] = new Array<ComboSelect>();
  dataTipoPoliza: ComboSelect[] = new Array<ComboSelect>();
  dataTipoEmpresa: ComboSelect[] = new Array<ComboSelect>();
  dataPolizasIndividiales: any;
  dataPolizasCoorporativoVehiculo: any[];
  dataPolizasCoorporativoAsistencia: any[];
  clienteMasivosIndividual: ClienteIndividualEntity;

  rutaCancelacion: boolean;
  rutaRenovacion: boolean;
  urlOrigen: string = "";
  urlAsesor: string = "";
  banderaCita: boolean = false;

  @ViewChild('agendarCita')
  modalAsesor: ModalComponent;

  userEmpresa: ClienteXCiudad;

  comboCiudad: CiudadClienteNombre[] = new Array<CiudadClienteNombre>();

  banderaCoorporativo: boolean = false;
  banderaTipoPoliza: boolean = false;

  userMasivos: Cliente;

  constructor(
    public utilsService: UtilService,
    public citasService: CitasAsesorVirtualService,
    public sesionStorageService: SessionStorageService,
    private consultarVAM: ConsultarUsuarioVAM,
    private consultarMasivo: ConsultarUsuarioMasivos,
  ) {
  }
  ngOnInit(): void {
    this.showLoader = "sk-loading";
    this.consultarVAM.iniciarUsuarioVAM();
    this.consultarMasivo.iniciarUsuarioMasivo();
    try {
      this.clienteVam = jQuery.parseJSON(this.sesionStorageService.retrieve("uservam"));
      this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
      this.userMasivos = jQuery.parseJSON(this.sesionStorageService.retrieve("usermasivos"));
    } catch (e) {
      this.usuario = this.sesionStorageService.retrieve("usuario");
    }
    this.ConsultarCitas(this.usuario.Cedula);
    this.ConsultarVehiculosCoorporativos();
    if (this.clienteVam)
      this.CargarPolizas(this.clienteVam, this.usuario.Cedula);

    if (this.userMasivos) {
      this.ConsultarDatosCliente();
      this.consultarNombreTitular();
    }
    this.showLoader = "";
  }

  ConsultarDatosCliente() {
    this.citasService.datosClienteIndividual().subscribe(datosClienteIndividual => {
      this.clienteMasivosIndividual = datosClienteIndividual;
    },
      error => {
        swal({
          title: 'Datos Cliente',
          text: "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
          type: 'error'
        });
        this.showLoader = "";
      });

  }

  AgruparRepetidosData() {
    let hash = {};
    this.dataTipoSeguro = this.dataTipoSeguro.filter(o => hash[o.Codigo] ? false : hash[o.Codigo] = true);
  }

  ConsultarCitas(ced: string) {
    this.citasService.GetCitas(ced).subscribe(
      result => {
        this.citas = JSON.parse(JSON.stringify(result));
      }
    );
  }

  onchangueTipoSeguro(event) {
    this.dataTipoPoliza = []
    this.tipoPoliza = 0;
    this.dataTipoEmpresa = []
    this.tipoEmpresa = 0;
    this.banderaTipoPoliza = false;
    this.banderaCoorporativo = false;
    if (this.tipoSeguro == 1) {
      if (this.dataPolizasIndividiales.SegurosVehiculo && this.dataPolizasIndividiales.SegurosVehiculo.length > 0)
        this.dataTipoPoliza.push({ Codigo: 2, Nombre: 'Individual' })

      if (this.dataPolizasCoorporativoVehiculo && this.dataPolizasCoorporativoVehiculo.length > 0)
        this.dataTipoPoliza.push({ Codigo: 1, Nombre: 'Coorporativo' })
    }
    else if (this.tipoSeguro == 2) {
      if (this.dataPolizasIndividiales.SegurosVivienda && this.dataPolizasIndividiales.SegurosVivienda.length > 0)
        this.dataTipoPoliza.push({ Codigo: 2, Nombre: 'Individual' })
    }
    else if (this.tipoSeguro == 3) {
      if (this.dataPolizasIndividiales.AsistenciaMedica && this.dataPolizasIndividiales.AsistenciaMedica.length > 0)
        this.dataTipoPoliza.push({ Codigo: 2, Nombre: 'Individual' })

      if (this.dataPolizasCoorporativoAsistencia && this.dataPolizasCoorporativoAsistencia.length > 0)
        this.dataTipoPoliza.push({ Codigo: 1, Nombre: 'Coorporativo' })
    }
    this.AgruparRepetidosData();

    if (this.dataTipoPoliza.length == 2)
      this.banderaTipoPoliza = true;

    if (this.dataTipoPoliza.length == 1) {
      if (this.dataTipoPoliza[0].Nombre == 'Individual')
        this.tipoPoliza = 2
      if (this.dataTipoPoliza[0].Nombre == 'Coorporativo'){
        this.tipoPoliza = 1  
        this.onchangueTipoPoliza(null);
        this.banderaCoorporativo = true;
      //this.banderaTipoPoliza = true;
      }
    }

  }

  onchangueTipoPoliza(event) {
    this.dataTipoEmpresa = []
    this.tipoEmpresa = 0;
    this.banderaCoorporativo = false;
    if (this.tipoSeguro == 1 && this.tipoPoliza == 1) {
      this.banderaCoorporativo = true;
      this.usuario.Corporativo.forEach(element => {
        this.dataTipoEmpresa.push({ Codigo: element.Codigocliente, Nombre: element.Cliente });
      });
    } else if (this.tipoSeguro == 3 && this.tipoPoliza == 1) {
      this.banderaCoorporativo = true;
      let contador = 1;
      this.usuario.VAM.forEach(element => {
        CIUDADES.forEach(a => {
          if (a.Codigo == element.CodigoCiudad) {
            this.dataTipoEmpresa.push({ Codigo: element.CodigoCliente, Nombre: element.NombreEmpresa });
            let clienteVamLista = new CiudadClienteNombre();
            clienteVamLista.CodigoCiudad = a.Codigo;
            clienteVamLista.CodigoCliente = element.CodigoCliente;
            clienteVamLista.Unidad = element.CodigoUnidad;
            clienteVamLista.NombreCombo = element.NombreEmpresa;
            clienteVamLista.idUnico = contador;
            this.comboCiudad.push(clienteVamLista);
            contador++;
          }
        });
      });
    }

  }

  onchangueTipoEmpresa(event) {
    if (this.tipoSeguro == 3 && this.tipoPoliza == 1) {
      let userVam = this.comboCiudad.filter(a => a.CodigoCliente == (event * 1))[0];
      this.usuario.VAM.forEach(element => {
        if (element.CodigoCiudad == userVam.CodigoCiudad && element.CodigoCliente == userVam.CodigoCliente) {
          this.sesionStorageService.store("uservam", JSON.stringify(element));
          this.clienteVam = jQuery.parseJSON(this.sesionStorageService.retrieve("uservam"));
          //this.consultaMenu(element);
        }
      });
    }
  }

  ConsultarVehiculosCoorporativos() {
    this.showLoader = "sk-loading";
    this.usuarioresumen = jQuery.parseJSON(this.sesionStorageService.retrieve("usercorporativo"));
    if (this.usuarioresumen == null || this.usuarioresumen == undefined) {
      this.usuarioresumen = this.usuario.Corporativo != null ? this.usuario.Corporativo[0] : null;
    }

    if (this.usuarioresumen) {
      this.citasService.consultaSegurosContratadosCoorporativos(this.usuarioresumen).subscribe(segurosContratados => {
        this.dataPolizasCoorporativoVehiculo = segurosContratados.VehiculosCorporativos;
        if (segurosContratados.VehiculosCorporativos && segurosContratados.VehiculosCorporativos.length > 0)
          this.dataTipoSeguro.push({ Codigo: 1, Nombre: "Vehículo" })

        this.AgruparRepetidosData();
      }, error => {
        swal({
          title: 'Pólizas Vehiculos Coorporativos',
          text: "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
          type: 'error'
        });
        this.showLoader = "";
      });
    }
  }

  consultarNombreTitular() {
    this.citasService.consultaSegurosContratados().subscribe(
      result => {
        this.dataPolizasIndividiales = result;
        if (result.SegurosVehiculo && result.SegurosVehiculo.length > 0)
          this.dataTipoSeguro.push({ Codigo: 1, Nombre: "Vehículo" })
        if (result.SegurosVivienda && result.SegurosVivienda.length > 0)
          this.dataTipoSeguro.push({ Codigo: 2, Nombre: "Vivienda" })
        if (result.AsistenciaMedica && result.AsistenciaMedica.length > 0)
          this.dataTipoSeguro.push({ Codigo: 3, Nombre: "Asistencia Médica" })
        /* if (result.Vida && result.Vida.length > 0)
          this.dataTipoSeguro.push({ Codigo: 4, Nombre: "Vida" }) */
        /*if (result.ProductosGenerales && result.ProductosGenerales.length > 0)
          this.dataTipoSeguro.push({ Codigo: 5, Nombre: "Productos Generales" })*/

        this.AgruparRepetidosData();
      },
      error => {
        swal({
          title: 'Pólizas Individuales',
          text: "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
          type: 'error'
        });
        this.showLoader = "";
      }
    );
  }

  CargarPolizas(vamTit: ClienteVAM, cedula: string) {
    var usuarioVam = new UsuarioVamTit();
    usuarioVam.CodigoCiudad = vamTit.CodigoCiudad;
    usuarioVam.CodigoCliente = vamTit.CodigoCliente;
    usuarioVam.CodigoUnidad = vamTit.CodigoUnidad;
    usuarioVam.Cedula = cedula;
    this.showLoader = "sk-loading";
    this.citasService.ConsultarPolizasVamTitular(usuarioVam).subscribe(
      result => {
        this.dataPolizasCoorporativoAsistencia = result;
        if (result && result.length > 0)
          this.dataTipoSeguro.push({ Codigo: 3, Nombre: "Asistencia Médica" })

        this.AgruparRepetidosData();
      },
      error => {
        swal({
          title: 'Pólizas Asistencia Coorporativos',
          text: "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
          type: 'error'
        });
        this.showLoader = "";
      }
    );

  }

  CancelarCita(cita: CitasPendientes) {
    this.cancelarCitaEntity = new AsesoriaVirtual();
    this.cancelarCitaEntity.CodigoAsesoria = cita.CodigoAsesoria;
    this.modalPass.open();
  }
  CancelModal() {
    this.modalPass.close();
  }
  EnviarCancelacion() {
    this.showLoader = "sk-loading";
    this.citasService.CancelarCita(this.cancelarCitaEntity).subscribe(
      result => {
        swal({
          title: 'Cancelación de Citas',
          text: "Su información ha sido enviada satisfactoriamente, su cita ha sido cancelada",
          type: 'success'
        });
        this.modalPass.close();
        this.ConsultarCitas(this.usuario.Cedula);
        this.showLoader = "";
      },
      error => {
        swal({
          title: 'Cancelación de Citas',
          text: "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
          type: 'error'
        });
        this.modalPass.close();
        this.showLoader = "";
      }
    );
  }

  CargarAsesor() {
    let bandera: number, poliza: any;
    let ban = 0;
    var bandTipoProceso = 5;
    var bandTipoProcesoVoorporativo = 0;
    let banderaCoorporativo = 0;
    let tipoProceso = 0;
    let banderaConsulta = 0;

    //---------------------------------INICIO INDIVIDUAL--------------------------------------------------
    if (this.tipoPoliza == 2) {
      switch (this.tipoSeguro) {
        case 1: //vehiculo
          bandera = 1
          poliza = this.dataPolizasIndividiales.SegurosVehiculo[0]
          break
        case 2: //vivienda
          bandera = 2
          poliza = this.dataPolizasIndividiales.SegurosVivienda[0]
          break
        case 3://asistenciaM
          bandera = 3
          poliza = this.dataPolizasIndividiales.AsistenciaMedica[0]
          break
        case 4://vida
          bandera = 4
          poliza = this.dataPolizasIndividiales.Vida[0]
          break
      }

      if (this.rutaCancelacion)
        bandTipoProceso = 4;

      if (this.rutaRenovacion)
        bandTipoProceso = 2;


      switch (bandera) {
        case 1:
        case 2:
          ban = 1;
          break
        case 3:
        case 4:
        case 5:
          ban = 2
          break;
      }
    }
    //---------------------------------FIN INDIVIDUAL--------------------------------------------------

    //---------------------------------INICIO COORPORATIVO---------------------------------------------
    else if (this.tipoPoliza == 1) {
      switch (this.tipoSeguro) {
        case 1: //vehiculo
          bandera = 1;
          bandTipoProcesoVoorporativo = 7;
          banderaCoorporativo = 4
          break
        case 2: //vivienda
          bandera = 2
          break
        case 3://asistenciaM
          bandera = 3
          bandTipoProcesoVoorporativo = 7;
          banderaCoorporativo = 3;
          break
        case 4://vida
          bandera = 4
          break
      }
    }
    //---------------------------------FIN COORPORATIVO---------------------------------------------
    banderaConsulta = this.tipoPoliza == 1 ? banderaCoorporativo : ban;
    tipoProceso = this.tipoPoliza == 1 ? bandTipoProcesoVoorporativo : bandTipoProceso;
    this.consultarUriAsesorVirtual(banderaConsulta, bandera, tipoProceso, poliza)
  }

  AbrirModalLeo(bandera, bandTipoProceso, poliza) {
    if (this.urlOrigen != null) {
      //---------------------------------INICIO INDIVIDUAL--------------------------------------------------
      if (this.tipoPoliza == 2) {
        switch (bandera) {
          case 1: //vehiculos
            this.urlAsesor = this.urlOrigen + this.clienteMasivosIndividual.Id + "/" + this.clienteMasivosIndividual.CiudadCodigo + "/" + bandTipoProceso + "/1/1/" + poliza.CodVehiculo + "/" + poliza.CodProducto + "/" + poliza.RamCod;
            break;
          case 2: //vivienda
            this.urlAsesor = this.urlOrigen + this.clienteMasivosIndividual.Id + "/" + this.clienteMasivosIndividual.CiudadCodigo + "/" + bandTipoProceso + "/2/1/" + poliza.CodVivienda + "/" + poliza.CodProducto + "/0";
            break;
          case 3: //asistencia medica
            this.urlAsesor = this.urlOrigen + this.clienteMasivosIndividual.Id + "/" + this.clienteMasivosIndividual.CiudadCodigo + "/" + bandTipoProceso + "/3/1/" + poliza.CodAccPer + "/" + poliza.CodProducto;
            break;
          case 4: //vida
            this.urlAsesor = this.urlOrigen + this.clienteMasivosIndividual.Id + "/" + this.clienteMasivosIndividual.CiudadCodigo + "/" + bandTipoProceso + "/3/1/" + poliza.CodAccPer + "/" + poliza.CodProducto;
            break;
          case 5: //otros ramos
            this.urlAsesor = this.urlOrigen + this.clienteMasivosIndividual.Id + "/" + this.clienteMasivosIndividual.CiudadCodigo + "/" + bandTipoProceso + "/4/1/" + poliza.CodProdGnral + "/" + poliza.CodProducto;
            break;
        }
        this.levantarModal()
      }
      //---------------------------------FIN INDIVIDUAL--------------------------------------------------

      //---------------------------------INICIO COORPORATIVO---------------------------------------------
      else if (this.tipoPoliza == 1) {
        switch (bandera) {
          case 1: //vehiculos
            this.urlAsesor = this.urlOrigen + this.usuarioresumen.Codigocliente + "/" + this.usuarioresumen.Ciudad + "/" + this.usuarioresumen.Unidad + "/1/1/" + this.usuarioresumen.Nombre + "/" + bandTipoProceso + "/1";
            //this.urlAsesor = this.urlOrigen + this.tipoEmpresa + "/" + this.usuarioresumen.Ciudad + "/" + this.usuarioresumen.Unidad + "/1/1/" + this.usuarioresumen.Nombre + "/" + bandTipoProceso + "/1";
            this.levantarModal()
            break;
          case 2: //vivienda
            break
          case 3: //asistencia medica
            const cli = new ClienteLogin();
            cli.Cedula = this.usuario.Cedula;
            this.userEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
            this.showLoader = "sk-loading";
            this.citasService.GetVamTitular(cli).subscribe(
              resulttit => {
                this.urlAsesor = this.urlOrigen + this.clienteVam.CodigoCliente + "/" + resulttit.CodigoTitular + "/" + this.clienteVam.CodigoCiudad + "/" + this.clienteVam.CodigoUnidad + "/6/1/0";
                //this.urlAsesor = this.urlOrigen + this.tipoEmpresa + "/" + resulttit.CodigoTitular + "/" + this.clienteVam.CodigoCiudad + "/" + this.clienteVam.CodigoUnidad + "/6/1/0";
                this.showLoader = "";
                this.levantarModal()
              },
              error => {
                swal({
                  title: 'Vam Titular',
                  text: "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
                  type: 'error'
                });
              }
            );
            break
          case 4: //vida
            break
          case 5: //otros ramos
            break;
        }
      }
      //---------------------------------FIN COORPORATIVO---------------------------------------------
    }
  }

  levantarModal() {
    console.log("url Asesor", this.urlAsesor);
    this.banderaCita = true;
    this.modalAsesor.open();
  }

  consultarUriAsesorVirtual(ban, bandera, bandTipoProceso, poliza) {
    this.utilsService.getUriAsesorVirtual(ban).subscribe(resultUri => {
      this.urlOrigen = resultUri;
      this.AbrirModalLeo(bandera, bandTipoProceso, poliza)
    },
      error => {
        swal({
          title: 'Pólizas Individuales',
          text: "Existio un error, por favor intentelo más tarde, lamentamos el inconveniente.",
          type: 'error'
        });
      });
  }

  CerrarModal() {
    this.banderaCita = false;
    this.urlAsesor = "";
  }

  validarBoton() {
    let result = true;
    if (this.tipoSeguro == 1 || this.tipoSeguro == 2 || this.tipoSeguro == 3)
      if (this.tipoPoliza == 2)
        result = false;
    if (this.tipoPoliza == 1)
      if (this.tipoEmpresa && this.tipoEmpresa != null && this.tipoEmpresa != 0)
        result = false;
    return result;
  }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/citas/citas-asesor-virtual.component.ts